import React from 'react';
import './RequestInfo.css';

const RequestInfo = ({ title }) => {
  return (
    <section className="request-info-section">
      <div className="request-info-container">
        <div className="request-info-spacer-left"></div>
        <p className="request-info-text">
          {title || <>Deploy AI That Regulators Trust.</>}
        </p>
        <button className="request-info-button" onClick={() => window.location.href = '/contact'}>
          Request for demo
        </button>
      </div>
    </section>
  );
};

export default RequestInfo; 